module.exports = __webpack_public_path__ + "static/media/downloadfile.1582dd82.svg";